'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _PlayerFactory2 = require('../models/PlayerFactory');

var _PlayerFactory3 = _interopRequireDefault(_PlayerFactory2);

var _isMobile = require('../../utils/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _JPlayer = require('./JPlayer');

var _JPlayer2 = _interopRequireDefault(_JPlayer);

var _JPlayerMobilePlayer = require('./JPlayerMobilePlayer');

var _JPlayerMobilePlayer2 = _interopRequireDefault(_JPlayerMobilePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * See JPlayer documentation for information on these configuration options:
 *  http://jplayer.org/latest/developer-guide/#jPlayer-constructor
 */
var JPlayerConfiguration = {
  swfPath: 'https://ajax.cdnjs.com/ajax/libs/jplayer/2.9.2/jplayer/jquery.jplayer.swf',
  mobile: {
    supplied: 'mp3,m4a,oga,m3u8a,m3ua',
    solution: 'html'
  },
  desktop: {
    supplied: 'mp3,m4a,oga,rtmpa,m3u8a,m3ua',
    solution: 'html,flash'
  }
}; /* eslint-disable no-underscore-dangle */


function createJPlayerLibrary(config) {
  var containerElement = document.createElement('div');
  containerElement.setAttribute('style', 'width: 0px; height: 0px; display: none;');
  document.body.appendChild(containerElement);
  return (0, _jquery2.default)(containerElement).jPlayer(config);
}

var JPlayerFactory = function (_PlayerFactory) {
  (0, _inherits3.default)(JPlayerFactory, _PlayerFactory);

  function JPlayerFactory() {
    (0, _classCallCheck3.default)(this, JPlayerFactory);

    var _this = (0, _possibleConstructorReturn3.default)(this, (JPlayerFactory.__proto__ || (0, _getPrototypeOf2.default)(JPlayerFactory)).call(this));

    _this.jPlayerMobileInstance = null;
    return _this;
  }

  (0, _createClass3.default)(JPlayerFactory, [{
    key: 'createPlayer',
    value: function createPlayer() {
      var playerConfig = {
        swfPath: JPlayerConfiguration.swfPath
      };

      if (!(0, _isMobile2.default)()) {
        playerConfig.supplied = JPlayerConfiguration.desktop.supplied;
        playerConfig.solution = JPlayerConfiguration.desktop.solution;
        var jPlayerDesktopLibraryInstance = createJPlayerLibrary(playerConfig);
        return new _JPlayer2.default(jPlayerDesktopLibraryInstance);
      }

      if (this.jPlayerMobileInstance) {
        return this.jPlayerMobileInstance;
      }

      playerConfig.supplied = JPlayerConfiguration.mobile.supplied;
      playerConfig.solution = JPlayerConfiguration.mobile.solution;
      var mobileJPlayerLibraryInstance = createJPlayerLibrary(playerConfig);
      this.jPlayerMobileInstance = new _JPlayerMobilePlayer2.default(mobileJPlayerLibraryInstance);
      return this.jPlayerMobileInstance;
    }
  }]);
  return JPlayerFactory;
}(_PlayerFactory3.default);

exports.default = JPlayerFactory;
//# sourceMappingURL=JPlayerFactory.js.map